// extracted by mini-css-extract-plugin
export default {"tabs":"d_n","tab-list":"d_p","tab":"d_q","active":"d_r"};